// extracted by mini-css-extract-plugin
export default {"container":"MaxWidthContainer_container__itVF0"};